import {Container, Spritesheet, Texture} from 'pixi.js';

export interface Size {
  width: number;
  height: number;
}

export class GameObjectUtils {
  public static placeByCenterParent(object: Container, parentSize?: Size): void {
    if (!object.parent) return;

    const parentWidth = (parentSize || object.parent)?.width;
    const parentHeight = (parentSize || object.parent)?.height;

    object.x = parentWidth / 2 - object.width / 2;
    object.y = parentHeight / 2 - object.height / 2;
  }

  public static createFramesFromSpriteSheet(spriteSheet: Spritesheet): Texture[] {
    const frameKeys = Object.keys(spriteSheet.data.frames);

    return frameKeys.map((frame) => Texture.from(frame));
  }
}
